import gql from 'graphql-tag'

const defaultState = () => {
    return {
        token: '',
        currentUser: {
            firstName: '',
            lastName: '',
            venueAccess: [
                {
                    accessType: '', // Admin | Editor
                    venue: {
                        id: '',
                    },
                },
            ],
        },
        currentLanguage: 'de',
    }
}

const state = defaultState()

const getters = {
    token: (state) => state.token,
    currentUser: (state) => state.currentUser,
    currentLanguage: (state) => state.currentLanguage,
}

const actions = {
    async signUpBusinessUser({ commit }, { vm, email, password, firstName, lastName }) {
        let success = false

        let payload = {
            email: email,
            password: password,
            user: {
                firstName: firstName,
                lastName: lastName,
            },
        }

        await vm.$apollo
            .mutate({
                mutation: gql`
                    mutation ($email: String!, $password: String!, $user: BusinessUserInput!) {
                        signUpBusinessUser(email: $email, password: $password, user: $user) {
                            token
                        }
                    }
                `,
                variables: payload,
            })
            .then(async (data) => {
                commit('updateToken', data.data.signUpBusinessUser.token)
                success = true
                return true
            })
            .catch(() => {
                this._vm.$pm.createToast('error', `Registrierung ist fehlgeschlagen.`)
            })
        return success
    },
    async signUpFacebookBusinessUser({ commit }, { vm, token }) {
        let success = false

        await vm.$apollo
            .mutate({
                mutation: gql`
                    mutation ($token: String!) {
                        signInBusinessUserWithFacebook(accessToken: $token) {
                            token
                        }
                    }
                `,
                variables: {
                    token,
                },
            })
            .then(async (data) => {
                commit('updateToken', data.data.signInBusinessUserWithFacebook.token)
                success = true
                return true
            })
            .catch((e) => {
                let msg = 'Es ist ein unerwarteter Fehler aufgetreten.'
                const code = e.graphQLErrors[0].extensions.code

                switch (code) {
                    case 'FB444': // The user has not selected any Facebook page from their profile.
                        msg = 'Bitte wähle eine Facebook Seite aus'
                        break
                    case 'FB401': // Missing page verification (blue or gray) OR less than 1,000 likes.
                        msg = 'Deine Seite ist kein verifizierter Veranstaltungsort'
                        break
                    case 'FB404': // The page has not specified a location.
                        msg = 'Deine Facebook-Seite benötigt einen angegebenen Ort'
                        break
                    case 'FB428': // The page category is not Dance & Night Club.
                        msg = 'Deine Facebook-Seite befindet sich nicht in der Kategorie "Tanz- und Nachtclub"'
                        break
                    default:
                        // An unexpected error has occurred.
                        msg = 'Es ist ein unerwarteter Fehler aufgetreten'
                }

                this._vm.$pm.createToast('error', msg)
            })
        return success
    },
    async login({ commit }, { vm, email, password }) {
        let success = false
        await vm.$apollo
            .mutate({
                mutation: gql`
                    mutation ($email: String!, $password: String!) {
                        signInBusinessUser(email: $email, password: $password) {
                            token
                        }
                    }
                `,
                variables: {
                    email: email,
                    password: password,
                },
            })
            .then(async (data) => {
                commit('updateToken', data.data.signInBusinessUser.token)
                success = true
                return true
            })
            .catch(() => {
                this._vm.$pm.createToast('error', `Anmeldung ist fehlgeschlagen.`)
            })
        return success
    },
    async logout({ commit }) {
        commit('reset', '')
        return true
    },
}

const mutations = {
    reset(state) {
        Object.assign(state, defaultState())
    },
    updateToken(state, payload) {
        state.token = payload
    },
    updateCurrentUser(state, payload) {
        state.updateCurrentUser = payload
    },
    updateCurrentLanguage(state, payload) {
        state.currentLanguage = payload
    },
}

export default {
    namespace: true,
    state,
    getters,
    actions,
    mutations,
}
